<input
  type="file"
  ngFileSelect
  [options]="options"
  (uploadOutput)="onUploadOutput($event)"
  [uploadInput]="uploadInput"
  (change)="handleFileSelect($event)"
  class="d-none"
/>
